// appels/create services
// Pure async functions only: no React, no hooks, no state. Parse at this boundary.
import { privateApi } from "@core/libs/axios";
import { parseWith } from "@core/parse";
import { AppelSchema, type Appel } from "../../_shared/types";

/**
 * `POST /cohorts/{id}/appels/`: create an appel in a cohort, saved as a draft from this moment. The
 * server numbers it, makes its code and answers `201` with the appel. Needs an `Idempotency-Key`: a
 * retry with the same key and payload returns the original appel instead of making a second. The
 * caller owns the key. Failures are left as `ApiError`; `classifyAppelFailure` reads them.
 */
export async function createAppel(
  cohortId: string,
  body: Record<string, string>,
  idempotencyKey: string
): Promise<Appel> {
  const path = `/cohorts/${cohortId}/appels/`;
  const dto = await privateApi
    .post<unknown>(path, body, {
      headers: { "Idempotency-Key": idempotencyKey },
    })
    .then((r) => r.data);
  return parseWith(AppelSchema, dto, `POST ${path}`);
}
